import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {isNotNullOrUndefined} from "../../providers/service/global-variables.service";

export type breakPointType = {
    maxWidth: number,
    sx: { percent: number | undefined, px: number | undefined, minWidth?: number | undefined,  },
    dx: { percent: number | undefined, px: number | undefined, minWidth?: number | undefined },
}

@Component({
    selector: 'app-split-screen',
    templateUrl: './split-screen.component.html',
    styleUrls: ['./split-screen.component.scss'],
    standalone: false
})
export class SplitScreenComponent implements OnInit {
    @ViewChild('containerSplitScreen', {static: false}) private containerSplitScreen: ElementRef | undefined;

    // i breakPoint devono essere ordinati in maniera ascendente per maxWidth
    @Input() breakPoint: breakPointType[] = [
        {
            maxWidth: 1000,
            sx: {percent: 0.8, px: 470, minWidth: 1},
            dx: {percent: 0.2, px: 0, minWidth: 1},
        },
    ]


    constructor() {
    }

    ngOnInit(): void {
    }

    get screenWidth() {
        if (isNotNullOrUndefined(this.containerSplitScreen) && isNotNullOrUndefined(this.containerSplitScreen?.nativeElement) && this.containerSplitScreen?.nativeElement.offsetWidth) {
            return this.containerSplitScreen.nativeElement.offsetWidth - 1;
        } else {
            return window.innerWidth
        }
    }


    getSxValue(value: any): string {
        if (isNotNullOrUndefined(value.sx.px) || isNotNullOrUndefined(value.sx.percent)) {
            return (value.sx.px) ? value.sx.px + 'px' : value.sx.percent + '%'
        } else {
            if (isNotNullOrUndefined(value.dx.px)) {
                return this.screenWidth - value.dx.px + 'px'
            } else {
                return 100 - value.dx.percent + '%'
            }
        }

    }

    getDxValue(value: any): string {
        if (isNotNullOrUndefined(value.dx.px) || isNotNullOrUndefined(value.dx.percent)) {
            return (value.dx.px) ? value.dx.px + 'px' : value.dx.percent + '%'
        } else {
            if (isNotNullOrUndefined(value.sx.px)) {
                return this.screenWidth - value.sx.px + 'px'
            } else {
                return 100 - value.sx.percent + '%'
            }
        }
    }

    get widthHeighBeforBreakPoint(): { sx: string, dx: string } {
        const screenWidth = this.screenWidth;
        const index = this.breakPoint.findIndex((point, index) => {
            if (index + 1 >= this.breakPoint.length) {
                return false
            }
            const currentBreakPoint = point.maxWidth;
            const successiveBreakPoint = this.breakPoint[index + 1].maxWidth;
            if (screenWidth >= successiveBreakPoint) {
                return true;
            } else {
                return false;
            }
        });
        if (index >= 0) {
            const sx = this.getSxValue(this.breakPoint[index]);
            const dx = this.getDxValue(this.breakPoint[index]);
            const width = {
                sx: sx,
                dx: dx,
            }
            return width;
        } else {
            const sx = this.getSxValue(this.breakPoint[this.breakPoint.length - 1]);
            const dx = this.getDxValue(this.breakPoint[this.breakPoint.length - 1]);
            const width = {
                sx: sx,
                dx: dx
            }
            return width
        }
    }
}
